import { render, staticRenderFns } from "./AddConfiguration.vue?vue&type=template&id=698b64fb&"
import script from "./AddConfiguration.vue?vue&type=script&lang=js&"
export * from "./AddConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports